import React from "react";

const TestScreen = () => {
  return (
    <div>
      <div className="fixed inset-0 bg-black flex items-center justify-center z-[9999]">
        <iframe width="100%" height="100%" src="/videos/AnandWon.gif" />

        <div className="absolute bottom-20 text-white text-6xl font-black">
          {/* 🏆 {FloorName[winner]} FLOOR LEADING */}
        </div>
      </div>
    </div>
  );
};

export default TestScreen;
